import { ThemeProperties } from '@fluidx/office-fluid-types';
import { AppStylingProvider } from './AppStylingProvider';
import { MeetingNotesCalendarViewThemingDefaults } from './MeetingNotesCalendarViewStylingValues';

/**
 * This is a specialized class that extends the default @AppStylingProvider implementation
 * while internally adding the styling values related to the meeting notes within calendar view
 * scenario.
 */
export class MeetingNotesCalendarViewAppStylingProvider extends AppStylingProvider {
  constructor() {
    super();
  }

  public get themeProperties(): ThemeProperties {
    let meetingAppThemingProperties = this.appThemeProperties ? new Map(this.appThemeProperties) : undefined;

    MeetingNotesCalendarViewThemingDefaults?.forEach((value: string, key: string) => {
      if (meetingAppThemingProperties === undefined) {
        meetingAppThemingProperties = new Map();
      }

      // We only feed the preset values if the host hasn't already set their own choice of values
      if (meetingAppThemingProperties.get(key) === undefined) {
        meetingAppThemingProperties.set(key, value);
      }
    });

    return meetingAppThemingProperties;
  }
}
